module.exports = __webpack_public_path__ + "img/nofound.72d422f4.png";